'use client'

import { useState } from 'react'

import { Button } from '@/core/components/form/button/button'
import { InputText } from '@/core/components/form/input-text'
import { toast } from '@/core/lib/toast'

import { SheetHead } from '@/features/veluvit/components/overlay/layer-parts'
import { INPUT_ZOOM_SAFE } from '@/features/veluvit/components/ui/field-class'
import { api } from '@/features/veluvit/services/api'
import { refreshSession } from '@/features/veluvit/services/session.service'
import { closeAll } from '@/features/veluvit/stores/overlay.store'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

import type { Room } from '@/features/veluvit/types/api.types'

/** 대화 관리 — 방 이름 바꾸기 · 보관/보관 해제 (v2 v2RoomMenu) */
export default function RoomMenuSheet({ room }: { room: Room }) {
  const [title, setTitle] = useState(room.title)
  const [pending, setPending] = useState(false)
  const patch = async (body: Record<string, unknown>, after?: () => void) => {
    setPending(true)
    try {
      await api<Room>(`/room/${room.id}/`, body, 'PATCH')
      after?.()
      await refreshSession()
      closeAll()
    } catch (e) {
      toast.show(e instanceof Error ? e.message : '다시 시도해 주세요.', {
        duration: 3200,
      })
    } finally {
      setPending(false)
    }
  }
  return (
    <>
      <SheetHead title="대화 관리" />
      <InputText
        id="roomTitle"
        label="대화 이름"
        classNames={{ ...INPUT_ZOOM_SAFE, container: 'mt-3' }}
        maxLength={100}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <Button
        variant="accent"
        size="lg"
        shape="pill"
        bold
        className="w-full mt-3"
        disabled={pending}
        onClick={() => patch({ title })}
      >
        이름 저장
      </Button>
      <Button
        variant="secondary"
        size="lg"
        shape="pill"
        bold
        className="w-full mt-2.5"
        disabled={pending}
        onClick={() =>
          patch({ archived: !room.archived }, () => {
            const session = useSessionStore.getState()
            if (session.selected[room.workId] === room.id)
              session.select(room.workId, null)
          })
        }
      >
        {room.archived ? '보관 해제' : '대화 보관'}
      </Button>
    </>
  )
}
